import * as React from "react";
import Svg, { Circle, Path } from "react-native-svg";

function SvgComponent(props) {
  return (
    <Svg
      width={119}
      height={119}
      viewBox="0 0 119 119"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <Circle cx={59.5} cy={59.5} r={59.5} fill="#00AB59" fillOpacity={0.05} />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M56.847 84.569c-19.465 0-35.25.872-35.25 1.947 0 1.076 15.785 1.948 35.25 1.948 19.466 0 35.252-.872 35.252-1.948 0-1.075-15.786-1.947-35.252-1.947z"
        fill="#D1D3D4"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M52.74 73.041l.167 2.064-2.787.165-.24-1.852 2.86-.377z"
        fill="#F7B48F"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M52.854 74.447c.926.293.953 2.601.393 3.272a.064.064 0 01-.012.011l-9.566-.48c-.182-.455.08-1.708 1.07-2.249.835-.455 3.287-.581 5.241-.606l.035.067s.754.443 1.7.369c.93-.074 1.133-.374 1.139-.384z"
        fill="#4C4B96"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M46.129 77.374l-2.46-.124c-.182-.455-.295-1.628.695-2.168.247-.135 1.012-.32 1.487-.404a3.043 3.043 0 01.278 2.696z"
        fill="#E6E7E8"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M53.525 77.091c-.063.261-.156.484-.278.628l-.012.011-9.566-.48c-.06-.15-.071-.386-.025-.654l9.881.495z"
        fill="#E6E7E8"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M66.865 51.384s.369 5.166-1.642 6.58c-2.012 1.417-13.02.468-14.009.262 0 0 .715 2.277 1.143 6.618.428 4.342.692 8.285.692 8.285-.628.571-2.62.839-3.549.473 0 0-3.535-14.952-3.332-17.163.204-2.21 1.471-2.945 4.07-3.199 2.6-.254 11.317-1.15 11.317-1.15l5.31-.706z"
        fill="#4C4B96"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M45.235 37.454c.47-.09.999.762 1.182 1.902.183 1.142-.05 2.14-.519 2.231-.47.09-.998-.761-1.182-1.902-.183-1.141.05-2.14.519-2.23z"
        fill="#E6E7E8"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M45.864 41.592c-.46.043-.968-.795-1.146-1.907-.154-.956-.016-1.813.31-2.119.46-.042.967.795 1.146 1.907.153.957.015 1.813-.31 2.12z"
        fill="#BCBEC0"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M45.568 39.52s-1.763.962-1.929 1.44c-.166.477-.384 2.853-.303 2.996.081.143.338.027.402.019.064-.01.065-1.944.275-2.639.21-.695 1.725-1.458 1.725-1.458l-.17-.357z"
        fill="#BCBEC0"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M40.007 42.44l-.061.01a7.255 7.255 0 00.023 6.912c-2.84-.469-2.274-6.566.038-6.922z"
        fill="#FFCB05"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M81.432 74.543a4.08 4.08 0 110 8.16 4.08 4.08 0 010-8.16zm0-4.123a8.203 8.203 0 010 16.405 8.203 8.203 0 010-16.405z"
        fill="#382423"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M77.831 76.704l1.655.537c.302-.425.74-.747 1.25-.902v-1.736a4.087 4.087 0 00-2.905 2.1zm.669 4.754l1.021-1.405a2.38 2.38 0 01-.475-1.43v-.06l-1.65-.537a4.068 4.068 0 001.103 3.432zm4.741.822l-1.02-1.405a2.381 2.381 0 01-1.578 0l-1.02 1.404c.546.27 1.16.422 1.81.422.649 0 1.263-.15 1.808-.421zm2.227-4.254l-1.65.537v.06a2.38 2.38 0 01-.475 1.43l1.022 1.405a4.069 4.069 0 001.103-3.432zm-3.34-3.423v1.736c.512.155.95.477 1.252.902l1.654-.537a4.09 4.09 0 00-2.905-2.101zm-.696-1.362a5.381 5.381 0 110 10.763 5.381 5.381 0 010-10.763z"
        fill="#A8AAAA"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M81.432 77.705a.918.918 0 110 1.836.918.918 0 010-1.836z"
        fill="#5F473D"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M29.622 74.543a4.08 4.08 0 110 8.159 4.08 4.08 0 010-8.16zm0-4.123a8.203 8.203 0 010 16.405 8.203 8.203 0 010-16.405z"
        fill="#382423"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M26.022 76.704l1.654.537c.302-.425.74-.747 1.25-.902v-1.736a4.085 4.085 0 00-2.904 2.1zm.668 4.754l1.021-1.405a2.38 2.38 0 01-.475-1.43v-.06l-1.648-.537a4.062 4.062 0 001.102 3.432zm4.741.822l-1.02-1.405a2.38 2.38 0 01-1.577 0l-1.02 1.404c.546.27 1.16.422 1.81.422a4.04 4.04 0 001.807-.421zm2.227-4.254l-1.65.537v.06a2.38 2.38 0 01-.475 1.43l1.022 1.405a4.069 4.069 0 001.103-3.432zm-3.339-3.423v1.736c.51.155.949.477 1.25.902l1.654-.537a4.086 4.086 0 00-2.904-2.101zm-.697-1.362a5.382 5.382 0 110 10.763 5.382 5.382 0 010-10.763z"
        fill="#A8AAAA"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M29.622 77.705a.918.918 0 110 1.836.918.918 0 010-1.836z"
        fill="#5F473D"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M84.24 63.596h3.554s1.256 2.426.994 3.057c-.262.631-1.442.572-1.442.572l-3.106-3.63z"
        fill="#FFCB05"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M82.015 63.006h4.484s2.016 3.07 2.029 4.278c.012 1.209-1.28 1.283-1.28 1.283l-5.233-5.56z"
        fill="#A8AAAA"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M60.342 31.539l1.429 2.447c-.025-.006-2.673 2.116-2.879 2.165L57.61 33.13l2.733-1.591z"
        fill="#F5C1A3"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M52.1 26.655c-.244 5.619 1.268 8.733 8.105 5.919l-.53-4.512-2.332-1.92-5.243.513z"
        fill="#F5C1A3"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M49.974 24.813c2.126 1.842 7.431-3.718 9.144-.841 0 0 1.81.482 2.472 2.15.662 1.67-.85 6.383-.85 6.383l-1.941-1.859c1.445-1.45-.616-2.68-1.16-.934l-.996-2.178c-2.146.84-6.719 1.021-6.67-2.72zM57.89 31.993c-.288.863-.64 1.653-1.79 1.784 0 0 .248.215.548.204.803-.03 1.542-.615 1.738-1.482l-.495-.506z"
        fill="#262B2C"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M51.568 25.149c4.387.046 5.83 2.185 5.72 6.027-.041 1.456.451 1.51 1.77 1.4 4.54-.376 7.178-8.242 1.763-11.398-4.574-2.667-10.038.817-9.253 3.971z"
        fill="#ED1C24"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M51.568 25.149c4.387.046 5.83 2.185 5.72 6.027-.04 1.456.451 1.51 1.769 1.4a4.236 4.236 0 001.627-.482c-1 .151-2.117.211-2.547-.168-.85-.75.174-3.661-1.889-5.857-1.392-1.482-3.517-1.51-4.752-1.373.012.15.035.301.072.453z"
        fill="#C61D23"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M59.246 27.776a1.314 1.314 0 10.005 2.628 1.314 1.314 0 00-.005-2.628z"
        fill="#262B2C"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M44.88 45.602s1.55-.157 3.1.086c1.55.244 8.071-1.625 8.717-1.816.645-.191 2.255-4.167 2.255-4.167l2.731 1.53s-2.536 4.02-3.584 4.649c-1.047.629-8.355 1.46-9.228 1.53-.873.07-3.9-.405-3.9-.405l-.09-1.407z"
        fill="#F7B48F"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M45.252 52.807s2.339-4.26 2.479-5.55c.14-1.291-4.014-2.55-4.014-2.55l-2.793 6.005 2.443 2.513 1.885-.418z"
        fill="#C61D23"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M87.04 69.882s1.115 1.602 2.931 4.29c1.815 2.687 2.304 3.875 2.304 3.875s-.943.594-2.863-1.36c-1.92-1.956-6.388-4.715-6.388-4.715l4.016-2.09z"
        fill="#382423"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M33.488 66.806c-3.704-.342-9.753 2.367-11.52 6.563 9.259-1.353 10.023.477 15.325 4.084 1.747 1.188 3.736.523 3.736.523l-7.541-11.17z"
        fill="#ED1C24"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M33.488 66.806c-1.104-.102-2.416.068-3.761.466.822.506 1.616 1.25 1.989 2.327.43 1.242.59 2.983.64 4.512 1.471.783 2.854 1.925 4.937 3.343 1.747 1.188 3.736.523 3.736.523l-7.541-11.171z"
        fill="#C61D23"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M40.923 50.713l4.329 2.094s.384.699-.28 2.374c-.663 1.675-2.269 4.573-2.723 8.063-.453 3.49-.453 11.834 3.596 11.974 4.05.14 9.6.14 9.6.14s1.168-.084 2.022-.555c.853-.47 1.155-1.156 1.155-1.156l14.557-3.91 16.861.175-.07 1.78s-5.55 1.396-10.298 2.339c-4.748.943-6.214 1.187-6.214 1.187l-.414 1.547s-9.745 2.538-19.065 2.887c-9.32.35-12.183-.698-12.183-.698s-4.434-3.036-5.83-8.063c-1.397-5.027-2.618-6.668-.42-10.997 2.2-4.329 5.377-9.181 5.377-9.181z"
        fill="#382423"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M54.722 73.156l.27 2.052-2.776.305-.331-1.837 2.837-.52z"
        fill="#F5C1A3"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M54.906 74.555c.94.245 1.083 2.55.556 3.248-.003.004-.008.008-.01.012h-9.578c-.205-.445-.006-1.71.955-2.299.81-.497 3.254-.746 5.204-.868l.039.065s.775.404 1.716.283c.925-.122 1.112-.432 1.118-.441z"
        fill="#4655A1"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M48.336 77.815h-2.462c-.205-.445-.376-1.611.584-2.2.24-.147.994-.373 1.466-.479a3.039 3.039 0 01.412 2.679z"
        fill="#fff"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M55.709 77.161c-.05.264-.133.49-.246.641l-.011.012h-9.577c-.068-.147-.092-.382-.058-.653h9.892z"
        fill="#fff"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M40.923 50.713s.837 1.187-.07 3.212c-.907 2.024-5.877 9.29-4.62 13.203 1.258 3.911 3.503 10.604 7.692 11.93 4.19 1.327 22.901-1.046 22.901-1.046s.768 3.63-4.399 3.7c-5.166.07-18.013 1.117-21.714-1.536-3.7-2.654-9.845-13.196-9.635-15.43.21-2.234 9.845-14.033 9.845-14.033z"
        fill="#ED1C24"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M66.598 79.765c-.432.94-1.52 1.91-4.17 1.947-4.455.06-14.617.846-19.705-.638 6.364.544 17.537-.041 23.875-1.309z"
        fill="#C61D23"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M56.842 62.582h27.02c1.248.295 5.525 4.515 6.179 7.33-5.702 1.433-23.897 4.15-31.418 3.736 4.166-4.887-1.845-7.822-1.781-11.066z"
        fill="#ED1C24"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M64.395 73.546a81.77 81.77 0 01-1.644.087 7.877 7.877 0 01-.53-2.78c0-5.692 6.901-9.098 15.412-7.605 4.13.725 7.88 2.47 10.648 4.725-2.555-1.838-5.813-3.244-9.362-3.867-8.197-1.436-14.844 1.844-14.844 7.325 0 .707.112 1.414.32 2.115z"
        fill="#C61D23"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M70.883 40.356H86.5a4.307 4.307 0 014.295 4.295v13.012a4.307 4.307 0 01-4.295 4.295H70.884V40.356z"
        fill="#ED1C24"
      />
      <Path d="M70.884 40.356h.694v21.602h-.694V40.356z" fill="#C61D23" />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M70.884 40.356h15.615c.791 0 1.534.217 2.171.594H70.884v-.594z"
        fill="#F58466"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M89.57 60.656a4.28 4.28 0 01-3.07 1.301H70.883v-1.3H89.57z"
        fill="#C61D23"
      />
      <Path d="M70.883 45.822h19.91v.78h-19.91v-.78z" fill="#C61D23" />
      <Path d="M56.843 61.57h27.019v1.012h-27.02V61.57z" fill="#ED1C24" />
      <Path d="M56.843 62.303h27.019v.279h-27.02v-.28z" fill="#C61D23" />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M56.842 61.57h13.064V58.15c0-.71-.582-1.34-1.29-1.292l-9.416.628c-1.294.087-2.357 1.061-2.357 2.357v1.728h-.001z"
        fill="#382423"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M68.67 56.855c-.02 0-.037 0-.056.002l-9.416.628c-1.293.087-2.356 1.061-2.356 2.357v.271c1.068.334 2.206.515 3.385.515 3.354-.001 6.367-1.458 8.442-3.773z"
        fill="#302120"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M81.484 76.147a2.479 2.479 0 010 4.952v.002l-11.575.461a2.95 2.95 0 11-.001-5.88l11.576.465z"
        fill="#5F6567"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M67.742 50.817s.628 5.141-1.309 6.656c-1.94 1.515-12.98 1.12-13.977.964 0 0 .828 2.237 1.473 6.552.646 4.314 1.107 8.24 1.107 8.24-.599.602-2.575.97-3.522.65 0 0-4.28-14.755-4.188-16.973.093-2.218 1.322-3.017 3.905-3.4 2.583-.384 11.245-1.717 11.245-1.717l5.266-.972z"
        fill="#4655A1"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M39.772 42.226c.301-.113.608-.187.913-.223l-.068.008a8.066 8.066 0 00-.228 7.675 3.888 3.888 0 01-1.118-.407 8.915 8.915 0 01.205-6.927c.096-.045.195-.088.296-.126z"
        fill="#DDE0E8"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M40.617 42.011a3.893 3.893 0 11-.229 7.675 8.072 8.072 0 01.228-7.675z"
        fill="#ED1C24"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M44.95 45.042a3.894 3.894 0 01-4.56 4.644 8.059 8.059 0 01-.85-3.188c1.075-.047 2.213-.198 3.29-.527a10.03 10.03 0 002.12-.928z"
        fill="#C61D23"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M45.706 47.588a.865.865 0 01.407.103l2.39 1.214-.715 1.554-2.44-1.24a.855.855 0 01.358-1.63z"
        fill="#382423"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M62.677 33.16c1.024 1.013 2.9 3.22 3.499 6.266.84 4.267 3.03 13.383 3.03 13.383s-2.496.665-6.039.661c-3.542-.004-4.5-1.595-4.5-1.595s-.733-7.783-1.087-11.397c-.355-3.613 1.184-5.096 1.184-5.096l2.676-2.356c.67-.589.547-.548 1.237.134z"
        fill="#ED1C24"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M62.319 32.775l.726.521c-1.327 1.115-4.248 2.793-5.704 4.575 0 0-.415-1.556.71-2.596.845-.78 2.64-1.928 3.485-2.454.451-.28.375-.34.783-.046z"
        fill="#C61D23"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M58.271 44.183c-.204.158-7.965 3.178-9.217 3.164-1.08-.012-1.255-.168-1.822-.073-.567.096-1.154.11-1.984.654-.83.545-.563 1.309-.469 1.336.095.027.09-.35.335-.672.244-.323 1.152-.512 1.152-.512s-.694.206-.897.618c-.203.413-.04 1.273.115 1.255.155-.018.048-.544.172-.803.123-.258.876-.746.876-.746s-.582.503-.638.96c-.054.458.262 1.029.371.896.11-.133-.071-.787.04-1.062.113-.273.607-.419.607-.419s-.39.189-.473.528c-.084.34.011.85.129 1.025.117.173.091-.394.303-.807.211-.413.897-.512.897-.512s.519-.052.814.294c.295.345.784.376 1.235-.025.45-.402 1.314-.706 1.89-.83.577-.124 7.127-1.103 8.016-1.589.89-.486 2.903-4.807 2.903-4.807l-3.017-1.061-1.338 3.188z"
        fill="#F5C1A3"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M48.076 48.799a.855.855 0 110 1.71.855.855 0 010-1.71z"
        fill="#382423"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M61.493 36.015c3.883-.313 1.656 7.322 1.361 8.1l-4.433-1.257c.147-1.76.91-6.667 3.072-6.843z"
        fill="#C61D23"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M83.904 66.16c-5.851-2.644-15.556-2.935-17.56 2.2 3.342-4.513 14.674-2.851 17.56-2.2zM23.48 72.05c2.473-2.296 4.529-3.373 6.984-4.18-3.274.443-5.786 2.467-6.983 4.18z"
        fill="#F58466"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M34.669 60.935a.822.822 0 01.309 1.118L33.72 64.27a.822.822 0 01-1.118.309.822.822 0 01-.309-1.118l1.257-2.217a.821.821 0 011.118-.31z"
        fill="#FFCB05"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M47.822 40.587c.684 0 1.33.946 1.44 2.112.112 1.166-.352 2.112-1.037 2.112-.684 0-1.33-.946-1.441-2.112-.11-1.166.354-2.111 1.038-2.111z"
        fill="#E6E7E8"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M48.173 44.81c-.664-.047-1.28-.974-1.388-2.11-.093-.978.218-1.8.724-2.04.664.046 1.28.973 1.389 2.11.092.976-.219 1.798-.725 2.04z"
        fill="#BCBEC0"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M48.024 42.7s-1.875.719-2.103 1.17c-.228.451-.759 2.779-.698 2.931.061.153.332.071.397.072.065 0 .322-1.917.622-2.58.3-.66 1.903-1.216 1.903-1.216l-.121-.378z"
        fill="#BCBEC0"
      />
      <Path
        d="M91.92 104.77c-1.011-.177-2.035-.278-3.021-.544-3.755-.998-6.725-3.122-8.887-6.32-2.136-3.148-2.983-6.662-2.553-10.442.77-6.7 5.991-12.249 12.603-13.437 7.723-1.378 15.232 3.122 17.596 10.606.329 1.05.442 2.162.657 3.249.026.139.051.29.076.442v1.922c-.025.113-.063.227-.076.34-.215 2.58-1.024 4.956-2.452 7.118-2.136 3.236-5.069 5.435-8.823 6.472-1.05.291-2.137.417-3.211.607-.632-.013-1.264-.013-1.91-.013zm3.565-18.077c-.013-.215-.026-.366-.026-.505 0-1.58.026-3.16-.012-4.74-.026-1.53-1.062-2.516-2.579-2.516-1.517 0-2.553.986-2.566 2.515-.026 2.63-.026 5.246 0 7.876.012 1.53.986 2.49 2.503 2.528 1.77.025 3.54.05 5.309-.013.53-.012 1.1-.215 1.542-.505.885-.57 1.188-1.795.847-2.946-.291-.973-1.15-1.63-2.225-1.668-.91-.038-1.82-.026-2.793-.026z"
        fill="#000"
        fillOpacity={0.9}
      />
      <Path
        d="M95.484 86.694c.974 0 1.884-.026 2.782 0 1.074.038 1.946.695 2.224 1.668.342 1.15.051 2.377-.847 2.946-.442.29-1.024.48-1.542.505-1.77.064-3.54.051-5.31.013-1.516-.025-2.49-.999-2.502-2.528-.025-2.63-.025-5.246 0-7.876.013-1.53 1.062-2.515 2.566-2.515 1.504 0 2.541.986 2.579 2.516.025 1.58.013 3.16.013 4.74.012.177.025.316.037.53z"
        fill="#fff"
      />
    </Svg>
  );
}

export default SvgComponent;
